import { Component, OnInit, Input } from '@angular/core';
import {Reservation} from '../../api/model/reservation/reservation.model';

@Component({
    selector: 'stay-mgmt-number-status',
    templateUrl: './number-status.component.html',
    styleUrls: ['./number-status.component.scss']
})
export class NumberStatusComponent implements OnInit {

    @Input() messages;
    private _reservation: Reservation;
    reservation_status: string;

    constructor() { }

    ngOnInit() {
    }

    @Input()
    set reservation(reservation: Reservation) {
      this._reservation = reservation;
      if (reservation && reservation.status) {
        if (reservation.status.toUpperCase() === 'CANCELED' || reservation.status.toUpperCase() === 'CANCELLED') {
          this.reservation_status = reservation.status;
        } else {
          this.reservation_status = 'CONFIRMED';
        }
      } else {
        this.reservation_status = 'CONFIRMED';
      }
    }
    get reservation() {
      return this._reservation;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/number-status/number-status.component.ts